// ==========================
//   FIXED PDP SALE TIMER
// ==========================

(function () {

  const targetDate = "2025-12-02";               
  const targetTime = "12:00:00";                 
  const pstOffset = "-08:00"; // PST fixed offset

  function elementsReady() {
    return (
      document.getElementById("days") &&
      document.getElementById("hours") &&
      document.getElementById("minutes") &&
      document.getElementById("seconds")
    );
  }

  // TRUE PST TARGET TIME
  function getTargetTime() {
    return new Date(`${targetDate}T${targetTime}${pstOffset}`).getTime();
  }

  const endTime = getTargetTime();

  function updateCountdown() {
    if (!elementsReady()) return;

    const now = Date.now();
    const distance = endTime - now;

    if (distance <= 0) {
      clearInterval(window.saleTimerInterval);
      const wrapper = document.querySelector(".countdown");
      if (wrapper) wrapper.style.display = "none";
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    document.getElementById("days").innerText = days;
    document.getElementById("hours").innerText = hours;
    document.getElementById("minutes").innerText = minutes;
    document.getElementById("seconds").innerText = seconds;
  }

  function startTimerWhenReady() {
    if (!elementsReady()) {
      setTimeout(startTimerWhenReady, 300);
      return;
    }

    updateCountdown();
    window.saleTimerInterval = setInterval(updateCountdown, 1000);
  }

  document.addEventListener("DOMContentLoaded", startTimerWhenReady);

})();

/* =====================================================
   Mobile PDP gallery thumbnails and video shortcut
   ===================================================== */

(() => {
  const mobileQuery = window.matchMedia("(max-width: 989px)");

  function initializeMobileGallery(gallery) {
    if (!gallery || gallery.dataset.mobileGalleryReady === "true") return;

    const slider = gallery.querySelector("slider-element");
    const mediaList = gallery.querySelector(".product__media-list");
    const previousButton = gallery.querySelector(
      '.indicators button[is="previous-button"]'
    );
    const nextButton = gallery.querySelector(
      '.indicators button[is="next-button"]'
    );
    const dots = Array.from(
      gallery.querySelectorAll(".mobile-gallery-dot")
    );

    const actionButton = gallery.querySelector(".mobile-gallery-action");

    if (!slider || !mediaList) return;

    gallery.dataset.mobileGalleryReady = "true";

    function getSlides() {
      const sliderSlides =
        Array.isArray(slider.itemsToShow) && slider.itemsToShow.length
          ? slider.itemsToShow
          : Array.from(
              mediaList.querySelectorAll(":scope > .product__media")
            );

      return sliderSlides.filter((slide) => !slide.hidden);
    }

    function getCurrentIndex() {
      const slides = getSlides();
      const selectedSlide =
        mediaList.querySelector(".product__media.selected") ||
        slides.find((slide) => slide.getAttribute("aria-current") === "true");

      const selectedIndex = slides.indexOf(selectedSlide);

      return selectedIndex >= 0 ? selectedIndex : 0;
    }

    function updateControls(activeMedia) {
      const slides = getSlides();
      let currentIndex = slides.indexOf(activeMedia);

      if (currentIndex < 0) {
        currentIndex = getCurrentIndex();
        activeMedia = slides[currentIndex];
      }

      const activeMediaId = activeMedia?.dataset.mediaId;

      dots.forEach((dot) => {
        dot.hidden = !slides.some((slide) => slide.dataset.mediaId === dot.dataset.mediaId);
        const isActive = dot.dataset.mediaId === activeMediaId;

        dot.classList.toggle("active", isActive);
        dot.setAttribute("aria-current", isActive ? "true" : "false");
      });

      if (actionButton) {
        actionButton.hidden = !slides.some((slide) => slide.dataset.mediaId === actionButton.dataset.mediaId);
      }
      const activeThumb = dots.find((dot) => dot.dataset.mediaId === activeMediaId);
      if (mobileQuery.matches && activeThumb && !activeThumb.hidden) {
        const strip = activeThumb.parentElement;
        const thumbLeft = activeThumb.offsetLeft;
        const thumbRight = thumbLeft + activeThumb.offsetWidth;
        // Leave visible thumbnails still; only reveal items outside the strip.
        if (thumbLeft < strip.scrollLeft || thumbRight > strip.scrollLeft + strip.clientWidth) {
          strip.scrollTo({
            left: thumbLeft - (strip.clientWidth - activeThumb.offsetWidth) / 2,
            behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth"
          });
        }
      }

      if (previousButton) {
        previousButton.disabled = currentIndex <= 0;
      }

      if (nextButton) {
        nextButton.disabled = currentIndex >= slides.length - 1;
      }
    }

    function selectSlide(index) {
      const slides = getSlides();

      if (!slides.length) return;

      const safeIndex = Math.max(
        0,
        Math.min(index, slides.length - 1)
      );

      if (typeof slider.select === "function") {
        /*
         * The theme's select method uses a one-based index.
         */
        // Use the slide's actual position so rapid taps do not accumulate
        // offsets from a carousel that is still moving.
        if (typeof slider.scrollToPosition === "function") {
          const target = slides[safeIndex];
          const first = slides[0];
          slider.scrollPosition = target.offsetLeft - first.offsetLeft;
          slider.scrollToPosition(slider.scrollPosition);
        } else {
          slider.select(safeIndex + 1, false);
        }
        // The slider:change event updates the selection after scrolling settles.
      }
    }

    previousButton?.addEventListener(
      "click",
      (event) => {
        if (!mobileQuery.matches) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        requestedVideo = null;
        selectSlide(getCurrentIndex() - 1);
      },
      true
    );

    nextButton?.addEventListener(
      "click",
      (event) => {
        if (!mobileQuery.matches) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        requestedVideo = null;
        selectSlide(getCurrentIndex() + 1);
      },
      true
    );

    dots.forEach((dot) => {
      dot.addEventListener("click", () => {
        requestedVideo = null;
        const slides = getSlides();
        const selectedIndex = slides.findIndex(
          (slide) => slide.dataset.mediaId === dot.dataset.mediaId
        );

        if (selectedIndex >= 0) {
          selectSlide(selectedIndex);
        }
      });
    });

    let requestedVideo = null;

    function playRequestedVideo(video) {
      video.paused = false;
      // Initialize the theme's lazy player and its normal play/pause listeners.
      // Native playback is invoked directly within the tap on supported videos.
      if (!video.hasAttribute('host')) {
        void video.player;
        const nativeVideo = video.querySelector('video');
        if (nativeVideo) {
          const attempt = nativeVideo.play();
          attempt?.catch((error) => {
            if (requestedVideo !== video || error.name !== 'NotAllowedError') return;
            nativeVideo.muted = true;
            nativeVideo.play()?.catch(() => {});
          });
          return;
        }
      }
      video.play();
    }

    actionButton?.addEventListener("click", () => {
      const slides = getSlides();
      const index = slides.findIndex((slide) => slide.dataset.mediaId === actionButton.dataset.mediaId);
      if (index < 0) return;

      selectSlide(index);
      // Start within the user's tap, without waiting for the scroll animation.
      // Use the theme player so loading, controls and pause-on-exit still work.
      const video = slides[index].querySelector('video-media');
      if (video && typeof video.play === "function") {
        requestedVideo = video;
        playRequestedVideo(video);
      }
    });

    // A gallery transition can pause a video that started while still offscreen.
    // Resume once the requested slide settles; never force playback on later swipes.
    slider.addEventListener('scrollend', () => {
      const video = requestedVideo;
      if (!video) return;
      // The theme debounces its page index, so scrollend can initially report
      // the old slide and queue a pause. Refresh it before finishing playback.
      if (typeof slider.update === 'function') slider.update();
      queueMicrotask(() => {
        if (requestedVideo !== video) return;
        const slide = video.closest('.product__media');
        const videoRect = slide.getBoundingClientRect();
        const sliderRect = slider.getBoundingClientRect();
        if (Math.abs(videoRect.left - sliderRect.left) < sliderRect.width / 2) {
          // Run after the theme's queued pause, even if it was playing when
          // the scrollend event began. Native play() is safe when already playing.
          playRequestedVideo(video);
        }
        requestedVideo = null;
      });
    });
    slider.addEventListener('pointerdown', () => { requestedVideo = null; });

    new MutationObserver(() => updateControls()).observe(mediaList, {
      subtree: true, attributes: true, attributeFilter: ["hidden"]
    });

    slider.addEventListener("slider:change", (event) => {
      updateControls(event.detail.currentElement);
    });

    const initialSlides = getSlides();
    const initialSlide =
      mediaList.querySelector(".product__media.selected") ||
      initialSlides[0];

    updateControls(initialSlide);
  }

  function initializeAllMobileGalleries(container = document) {
    if (container.matches?.("media-gallery")) {
      initializeMobileGallery(container);
    }

    container
      .querySelectorAll?.("media-gallery")
      .forEach(initializeMobileGallery);
  }

  function startMobileGalleries() {
    initializeAllMobileGalleries();
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      startMobileGalleries
    );
  } else {
    startMobileGalleries();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initializeAllMobileGalleries(event.target);
  });
})();
